import { api } from "../api";
import { Project } from "../models";

const SinglePageService = {
  getProjectSidebar: async () => {
    //@ts-ignore
    return await api.getInstance().get('/project-sidebar', { public: true });
  },
  getAbout: async () => {
    //@ts-ignore
    return await api.getInstance().get('/about', { public: true });
  }
};


export default SinglePageService;